export default __webpack_public_path__ + "static/media/gallery_03.8400e8d9.jpg";